import Single from "./Pagination/Single";
import Index from "./Pagination/Index";
import Full from "./Pagination/Full";

export default Object.assign(Index, { Full, Single });
